import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RESET_PASSWORD_WARNING } from '@ftr/api-shared'
import { ResetComponent } from '../../lib/reset/reset.component'

@Component({
  selector: 'ftr-reset-page',
  template: '<ftr-reset [showResetPasswordWarning]="showResetPasswordWarning" />',
  imports: [ResetComponent],
})
export class ResetPage implements OnInit {
  showResetPasswordWarning: boolean

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.showResetPasswordWarning = this.route.snapshot.queryParams[RESET_PASSWORD_WARNING]
  }
}
